import { createSlice } from '@reduxjs/toolkit';

const VotingByResolutionSlice = createSlice({
  name: 'votingByResolution',
  initialState: {},
  reducers: {},
  extraReducers: () => {},
});

export default VotingByResolutionSlice.reducer;
